exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.faq-serach-area[data-v-0930a992]{\n.faq-area-title{\n@include min{\n      font-size: 16px;\n}\n@include max{\n      font-size: 85%;\n}\n}\n.faq-area-link {\n    display: block;\n}\n}\n", ""]);

// exports
